module.exports = __webpack_public_path__ + "static/media/govt.02327232.svg";